import { useState } from 'react';

import { Text } from '../../../../cdl/Text/Text';
import { translate } from '../../../../common/helpers/translate.helper';
import { InteractiveTranslation } from '../../../../common/InteractiveTranslation';

import { BackupCodeModal } from './BackupCodeModal';

export const BackupCodeSection = () => {
    const [isBackupCodeModalOpen, setIsBackupCodeModalOpen] = useState(false);

    return (
        <>
            <Text variant="small" color="foreground.muted">
                <InteractiveTranslation
                    translation={translate('mfa.authenticator.backupCodePrompt')}
                    onClick={() => setIsBackupCodeModalOpen(true)}
                />
            </Text>
            <BackupCodeModal isOpen={isBackupCodeModalOpen} onClose={() => setIsBackupCodeModalOpen(false)} />
        </>
    );
};
